import { render, staticRenderFns } from "./GoodsInfo.vue?vue&type=template&id=0253f486&scoped=true"
import script from "./GoodsInfo.vue?vue&type=script&lang=js"
export * from "./GoodsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0253f486",
  null
  
)

export default component.exports